// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1_FKb","name":"ConsentHeader_name__2AgP4","birthday":"ConsentHeader_birthday__Y3poJ","skeleton":"ConsentHeader_skeleton__EuRg2"};